export const DEFAULT_DATA = {}
export const DEFAULT_DATA_ITEM = {
  loading: false,
  loaded: false as const,
  error: undefined,
  data: undefined,
}

export const DEFAULT_LIST_ITEMS = {}

export const DEFAULT_ITEM_STATE = {
  loading: false,
  loaded: false,
  error: undefined,
  items: [],
  meta: undefined,
  filters: undefined,
  pagination: undefined,
  sort: undefined,
}
